import React from 'react';

const FounderIntro = () => {
  const founders = [
    {
      id: 1,
      name: 'Akanksha Jagwani',
      title: 'Co-founder and CEO',
      image: '/images/img_about_aj.png',
      bio: '“I head business development, partnering with fabs worldwide to deploy AI across their manufacturing lines. I studied Mechanical Engineering at IIT and have worked with Hyundai Motors, General Electric, Washington University, and A*STAR before starting this journey. When I’m not building the future of semiconductor manufacturing, you’ll probably find me dancing or experimenting with healthy foods that actually taste great!”',
    },
    {
      id: 2,
      name: 'Avni Agarwal',
      title: 'Co-founder and CTO',
      image: '/images/img_about_avani.png',
      bio: '“I drive the technology and product vision at SixSense, turning complex manufacturing challenges into scalable AI solutions. I graduated in Computer Engineering from NIT Allahabad in 2016, and spent a few years at Visa and D.E. Shaw before diving into the startup world.I enjoy building things that matter, and outside of work, I love board games, trying new food, and suspense movies. My team calls me competitive — we take our game nights pretty seriously!”',
    },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4">
      {/* Section Title */}
      <div className="text-center mb-[172px]">
        <h2 className="text-3xl md:text-4xl font-medium text-[#212A31] mb-4">Meet the Founders</h2>
      </div>
      {/* Founder Cards */}
      <div className="grid md:grid-cols-2 gap-40 md:gap-8 max-w-4xl mx-auto">
        {founders.map((founder) => (
          <div
            key={founder.id}
            className="bg-white rounded-lg p-9 pt-36 shadow-[0_2px_6px_0_#0000002E] text-center relative"
          >
            {/* Profile Image */}
            <div className="w-64 h-64 mx-auto rounded-full overflow-hidden absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <img src={founder.image} alt={founder.name} className="w-full h-full object-cover" />
            </div>

            {/* Name and Title */}
            <div className="mb-6">
              <h3 className="text-2xl font-medium text-[#212A31] mb-2">{founder.name}</h3>
              <p className="text-base font-normal text-[#486075] ">{founder.title}</p>
            </div>

            {/* Bio */}
            <div className="text-[1rem] font-normal text-[#324452] leading-relaxed">
              <p>{founder.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FounderIntro;
